import React, { Component } from 'react'
import styled from 'styled-components'
import Helmet from 'react-helmet'

export default class extends Component {
  render () {
    return (
      <Container>
        <Helmet>
          <title>RUNNABLES CO., LTD. - Digital Products for Real World Problems</title>
        </Helmet>
        {false && (
          <Navbar>
            <GridContainer style={{ textAlign: 'right' }}>
              <NavMenus>
                <NavMenu>ABOUT</NavMenu>
                <NavMenu>WORKS</NavMenu>
              </NavMenus>
            </GridContainer>
          </Navbar>
        )}
        <Section1>
          <Horizontal>
            <Vertical>
              <Section1ContentWrapper>
                <Logo src='/images/logo.png' />
                <Section1Line1>RUNNABLES CO., LTD.</Section1Line1>
                <Section1Line2>Digital Products for Real World Problems</Section1Line2>
              </Section1ContentWrapper>
              <Section1OurProcessWrapper>
                <OurProcessText>OUR PROCESS</OurProcessText>
                <IconDown src='/images/icon-down.svg' />
              </Section1OurProcessWrapper>
            </Vertical>
          </Horizontal>
        </Section1>
        <Section2>
          <GridContainer>

            <OurProcessHead>OUR PROCESS</OurProcessHead>
            <Section2Mobile src='/images/section2-mobile.png' />
            <DescriptionBox>
              <DescriptionTextBox>
                <DescriptionBoxText1>It starts with Whire</DescriptionBoxText1>
                <br />
                <DescriptionBoxText1>(Why + Wireframe)</DescriptionBoxText1>
                <br />
                <DescriptionBoxText2>UX Designing</DescriptionBoxText2>
                <br />
                <br />
                <DescriptionBoxText3>
                  <div>Why? + Wirefirame:</div>
                  <div>We first work with you to come up</div>
                  <div>with relevant features for your audience.</div>
                </DescriptionBoxText3>
                <br />
                <br />
                <DescriptionBoxText3>
                  <div>Our design team will then</div>
                  <div>work on the experience of the product</div>
                  <div>optimized for your audience.</div>
                </DescriptionBoxText3>
              </DescriptionTextBox>
              <SuccessCasesLabel>Success Cases</SuccessCasesLabel>
              <div>
                <SuccessCase href='https://apps.apple.com/th/app/resus-ultrasound/id1033017112'>
                  <img alt='RESUS Ultrasound' src='/images/logo-resus.png' />
                </SuccessCase>
                <SuccessCase href='https://thecommonsbkk.com/'>
                  <img alt='The Commons' src='/images/logo-thecommons.png' />
                </SuccessCase>
                <SuccessCase href='http://microbrik.com/'>
                  <img alt='Microbrik' style={{ width: '100%', objectFit: 'contain' }} src='/images/logo-microbrik.png' />
                </SuccessCase>
              </div>
            </DescriptionBox>
          </GridContainer>
        </Section2>
        <Section3>
          <GridContainer>
            <OurProcessHead>OUR PROCESS</OurProcessHead>
            <RunForFood>
              <img alt='' src='/images/section3-mobile.png' />
            </RunForFood>
            <SublimeText>
              <TopGrey />
              <BottomGrey>
                <LeftGrey />
                <RightGrey>
                  <img alt='' src='/images/section3-code.png' />
                </RightGrey>
              </BottomGrey>
            </SublimeText>
            <Server>
              <img alt='' src='/images/section3-server.png' />
            </Server>
            <DescriptionBox>
              <DescriptionTextBox>
                <DescriptionBoxText1>Then The Magic</DescriptionBoxText1>
                <DescriptionBoxText2>Coding</DescriptionBoxText2>
                <br />
                <br />
                <DescriptionBoxText3>Our tech team use cutting edge web and mobile technologies to turn design into reality.</DescriptionBoxText3>
                <br />
                <br />
                <DescriptionBoxText3>We make sure that the product withstand real life loads while still perform at dazzling user experience.</DescriptionBoxText3>
              </DescriptionTextBox>
              <Techbox>
                <DescriptionBoxText1>Technologies</DescriptionBoxText1>
                <br />
                <ImgTech src='/images/tech-ico.png' />
              </Techbox>
              <SuccessCasesLabel>Success Cases</SuccessCasesLabel>
              <div>
                <SuccessCase href='https://apps.apple.com/th/app/resus-ultrasound/id1033017112'>
                  <img alt='RESUS Ultrasound' src='/images/logo-resus.png' />
                </SuccessCase>
                <SuccessCase href='https://thecommonsbkk.com/'>
                  <img alt='The Commons' src='/images/logo-thecommons.png' />
                </SuccessCase>
                <SuccessCase href='http://microbrik.com/'>
                  <img alt='Microbrik' style={{ width: '100%', objectFit: 'contain' }} src='/images/logo-microbrik.png' />
                </SuccessCase>
              </div>
            </DescriptionBox>
          </GridContainer>
        </Section3>
        <Section4>
          <GridContainer>
            <OurProcessHead>OUR PROCESS</OurProcessHead>
            <Section4Mobile src='/images/section4-mobile.png' />
            <Section4Graph src='/images/section4-graph.png' />
            <DescriptionBox>
              <DescriptionTextBox>
                <DescriptionBoxText1>Maintain the Love</DescriptionBoxText1>
                <DescriptionBoxText2>Tech Support</DescriptionBoxText2>
                <br />
                <br />
                <DescriptionBoxText3>We make sure your users stays happy with the app with our maintenance and tech support.</DescriptionBoxText3>
                <br />
                <br />
                <DescriptionBoxText3>We also offers analytics data for your app that you can turn into actionable metrics.</DescriptionBoxText3>
              </DescriptionTextBox>
              <SuccessCasesLabel>Success Cases</SuccessCasesLabel>
              <div>
                <SuccessCase href='https://apps.apple.com/th/app/resus-ultrasound/id1033017112'>
                  <img alt='RESUS Ultrasound' src='/images/logo-resus.png' />
                </SuccessCase>
                <SuccessCase href='https://thecommonsbkk.com/'>
                  <img alt='The Commons' src='/images/logo-thecommons.png' />
                </SuccessCase>
                <SuccessCase href='http://microbrik.com/'>
                  <img alt='Microbrik' style={{ width: '100%', objectFit: 'contain' }} src='/images/logo-microbrik.png' />
                </SuccessCase>
              </div>
            </DescriptionBox>
          </GridContainer>
        </Section4>
        <Section5>
          <GridContainer>
            <Section5Head>Our Clients</Section5Head>
            <div>
              {['microbrik', 'sme', 'resus', 'meditech', 'lotus', 'iamdr', 'dtac', 'fonterra'].map(key =>
                <ClientItemWrapper key={key}>
                  <ClientImage src={`/images/logo-${key}.png`} />
                </ClientItemWrapper>
              )}
            </div>
          </GridContainer>
        </Section5>
      </Container>
    )
  }
}

const Container = styled.div`

`
const Navbar = styled.nav`
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  height: 45px;
  line-height: 45px;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 9999;
`
const NavMenus = styled.div`
  display: inline-block;
  vertical-align: top;
`
const NavMenu = styled.div`
  display: inline-block;
  vertical-align: top;
  line-height: 45px;
  color: white;
  font-size: 14px;
  padding: 0px 25px;
  font-family: SourceSansPro;
  cursor: pointer;
  transition: opacity 0.3s ease;
  &:hover { opacity: 0.8; }
`
const GridContainer = styled.div`
  width: 100%;
  max-width: 1024px;
  margin: 0 auto;
  @media(max-width: 767px) {
    margin: 0px 10px;
    width: calc(100% - 20px);
  }
`
const Section = styled.section`
  @media(min-width: 768px) {
    width: 100vw;
    height: 100vh;
  }
  @media(max-width: 767px) {
    padding: 20px 0px;
  }
`
const Section1 = styled(Section)`
  background-image: url('images/section1-background.png');
  background-size: cover;
  position: relative;
  &:before {
    content: '';
    position: absolute;
    top: 0px; left: 0px; right: 0px; bottom: 0px;
    z-index: 1;
    background-color: rgba(53, 73, 94, 0.8);
  }
`
const Horizontal = styled.div`
  text-align: center;
  white-space: nowrap;
  background-color: ${props => props.theme[props.backgroundColor] || props.backgroundColor};
  &:before {
    content: '';
    display: inline-block;
    vertical-align: middle;
    width: 0;
    height: ${props => props.height || '100vh'};
  }
`
const Vertical = styled.div`
  display: inline-block;
  vertical-align: middle;
  top: 0;
  text-align: center;
`
const Section1ContentWrapper = styled.div`
  position: relative;
  z-index: 2;
  white-space: initial;
`
const Logo = styled.img`
  width: 108px;
  height: 108px;
`
const Section1Line1 = styled.div`
  font-size: 44px;
  font-family: FVAlmelo;
  margin-top: 16px;
  margin-bottom: 12px;
  color: white;
`
const Section1Line2 = styled.div`
  font-size: 28px;
  font-family: SourceSansPro;
  color: white;
`
const Section1OurProcessWrapper = styled.div`
  position: absolute;
  width: 200px;
  bottom: 20px;
  left: calc(50vw - 100px);
  z-index: 2;
`
const OurProcessText = styled.div`
  font-size: 20px;
  color: white;
  font-family: FVAlmelo;
`
const IconDown = styled.img`
  width: 21px;
  margin-top: 10px;
`
const Section2 = styled(Section)`
  background-image: url('images/section2-background.png');
  background-size: cover;
  position: relative;
`
const OurProcessHead = styled.div`
  font-size: 28px;
  font-family: FVAlmelo;
  color: white;
  position: absolute;
  top: 100px;
  text-shadow: 2px 2px rgba(0, 0, 0, 0.3);
  @media(max-width: 767px) { display: none; }
`
const Section2Mobile = styled.img`
  @media(min-width: 768px) {
    height: 80vh;
    position: absolute;
    top: 100px;
    left: 35vw;
  }
  @media(max-width: 767px) {
    height: 50vh;
    position: absolute;
    top: 100px;
    left: calc(50vw - 12.25vh);
  }
`
const Section2Text = styled.div`
  position: absolute;
  top: 100px;
  left: calc(50vw + 19.6vh + 60px);
`
const Section2TextHead = styled.div`
  color: white;
  font-family: SourceSansPro;
  font-size: 32px;
  font-weight: 500;
`
const Section2TextBody = styled.div`
  color: white;
  font-family: SourceSansPro;
  font-size: 22px;
  margin-top: 20px;
`
const SuccessCasesLabel = styled.div`
  margin-top: 30px;
  margin-bottom: 10px;
  font-family: SourceSansPro;
  font-size: 18px;
  font-weight: 500;
  color: white;
`
const SuccessCase = styled.a`
  display: inline-block;
  vertical-align: top;
  width: 46px;
  height: 46px;
  border: 1px solid white;
  margin-right: 12px;
  background-color: white;
  padding: 10px;
  text-align: center;
  cursor: pointer;
  &:hover {
    border: 1px solid #31bdba;
  }
  > img {
    height: 48px;
    object-fit: cover;
  }
`
const Section3 = styled(Section)`
  display: block;
  background-color: #0fbfcf;
  position: relative;
  overflow: hidden;
`
const RunForFood = styled.div`
  @media(min-width: 768px) {
    > img {
      display: block;
      width: 250px;
    }
  }
  @media(max-width: 767px) {
    display: none;
  }
  z-index: 5;
  width: 245px;
  position: relative;
  margin: 0 auto;
  top: 90px;
  border-radius: 50px;
  box-shadow: #0998a4 1px 1px, #0998a4 2px 2px, #0998a4 3px 3px, #0998a5 4px 4px, #0999a5 5px 5px, #0999a5 6px 6px, #0999a5 7px 7px, #0999a5 8px 8px, #0999a5 9px 9px, #0999a5 10px 10px, #0999a5 11px 11px, #0999a6 12px 12px, #0999a6 13px 13px, #099aa6 14px 14px, #099aa6 15px 15px, #099aa6 16px 16px, #099aa6 17px 17px, #099aa6 18px 18px, #099aa6 19px 19px, #099aa7 20px 20px, #099aa7 21px 21px, #099aa7 22px 22px, #099ba7 23px 23px, #099ba7 24px 24px, #099ba7 25px 25px, #099ba7 26px 26px, #099ba7 27px 27px, #099ba8 28px 28px, #099ba8 29px 29px, #099ba8 30px 30px, #099ba8 31px 31px, #099ca8 32px 32px, #099ca8 33px 33px, #099ca8 34px 34px, #0a9ca8 35px 35px, #0a9ca9 36px 36px, #0a9ca9 37px 37px, #0a9ca9 38px 38px, #0a9ca9 39px 39px, #0a9ca9 40px 40px, #0a9da9 41px 41px, #0a9da9 42px 42px, #0a9da9 43px 43px, #0a9daa 44px 44px, #0a9daa 45px 45px, #0a9daa 46px 46px, #0a9daa 47px 47px, #0a9daa 48px 48px, #0a9daa 49px 49px, #0a9eaa 50px 50px, #0a9eaa 51px 51px, #0a9eab 52px 52px, #0a9eab 53px 53px, #0a9eab 54px 54px, #0a9eab 55px 55px, #0a9eab 56px 56px, #0a9eab 57px 57px, #0a9eab 58px 58px, #0a9fab 59px 59px, #0a9fac 60px 60px, #0a9fac 61px 61px, #0a9fac 62px 62px, #0a9fac 63px 63px, #0a9fac 64px 64px, #0a9fac 65px 65px, #0a9fac 66px 66px, #0a9fac 67px 67px, #0aa0ad 68px 68px, #0aa0ad 69px 69px, #0aa0ad 70px 70px, #0aa0ad 71px 71px, #0aa0ad 72px 72px, #0aa0ad 73px 73px, #0aa0ad 74px 74px, #0aa0ad 75px 75px, #0aa0ae 76px 76px, #0aa1ae 77px 77px, #0aa1ae 78px 78px, #0aa1ae 79px 79px, #0aa1ae 80px 80px, #0aa1ae 81px 81px, #0aa1ae 82px 82px, #0aa1ae 83px 83px, #0aa1af 84px 84px, #0aa1af 85px 85px, #0aa2af 86px 86px, #0aa2af 87px 87px, #0aa2af 88px 88px, #0aa2af 89px 89px, #0aa2af 90px 90px, #0aa2af 91px 91px, #0aa2b0 92px 92px, #0aa2b0 93px 93px, #0aa2b0 94px 94px, #0aa3b0 95px 95px, #0aa3b0 96px 96px, #0aa3b0 97px 97px, #0aa3b0 98px 98px, #0aa3b0 99px 99px, #0aa3b1 100px 100px, #0aa3b1 101px 101px, #0aa3b1 102px 102px, #0aa3b1 103px 103px, #0aa4b1 104px 104px, #0ba4b1 105px 105px, #0ba4b1 106px 106px, #0ba4b1 107px 107px, #0ba4b2 108px 108px, #0ba4b2 109px 109px, #0ba4b2 110px 110px, #0ba4b2 111px 111px, #0ba4b2 112px 112px, #0ba5b2 113px 113px, #0ba5b2 114px 114px, #0ba5b2 115px 115px, #0ba5b3 116px 116px, #0ba5b3 117px 117px, #0ba5b3 118px 118px, #0ba5b3 119px 119px, #0ba5b3 120px 120px, #0ba5b3 121px 121px, #0ba6b3 122px 122px, #0ba6b3 123px 123px, #0ba6b4 124px 124px, #0ba6b4 125px 125px, #0ba6b4 126px 126px, #0ba6b4 127px 127px, #0ba6b4 128px 128px, #0ba6b4 129px 129px, #0ba6b4 130px 130px, #0ba7b4 131px 131px, #0ba7b5 132px 132px, #0ba7b5 133px 133px, #0ba7b5 134px 134px, #0ba7b5 135px 135px, #0ba7b5 136px 136px, #0ba7b5 137px 137px, #0ba7b5 138px 138px, #0ba7b5 139px 139px, #0ba8b6 140px 140px, #0ba8b6 141px 141px, #0ba8b6 142px 142px, #0ba8b6 143px 143px, #0ba8b6 144px 144px, #0ba8b6 145px 145px, #0ba8b6 146px 146px, #0ba8b6 147px 147px, #0ba8b7 148px 148px, #0ba9b7 149px 149px, #0ba9b7 150px 150px, #0ba9b7 151px 151px, #0ba9b7 152px 152px, #0ba9b7 153px 153px, #0ba9b7 154px 154px, #0ba9b7 155px 155px, #0ba9b8 156px 156px, #0ba9b8 157px 157px, #0baab8 158px 158px, #0baab8 159px 159px, #0baab8 160px 160px, #0baab8 161px 161px, #0baab8 162px 162px, #0baab8 163px 163px, #0baab9 164px 164px, #0baab9 165px 165px, #0baab9 166px 166px, #0babb9 167px 167px, #0babb9 168px 168px, #0babb9 169px 169px, #0babb9 170px 170px, #0babb9 171px 171px, #0babba 172px 172px, #0babba 173px 173px, #0babba 174px 174px, #0cacba 175px 175px, #0cacba 176px 176px, #0cacba 177px 177px, #0cacba 178px 178px, #0cacbb 179px 179px, #0cacbb 180px 180px, #0cacbb 181px 181px, #0cacbb 182px 182px, #0cacbb 183px 183px, #0cadbb 184px 184px, #0cadbb 185px 185px, #0cadbb 186px 186px, #0cadbc 187px 187px, #0cadbc 188px 188px, #0cadbc 189px 189px, #0cadbc 190px 190px, #0cadbc 191px 191px, #0cadbc 192px 192px, #0caebc 193px 193px, #0caebc 194px 194px, #0caebd 195px 195px, #0caebd 196px 196px, #0caebd 197px 197px, #0caebd 198px 198px, #0caebd 199px 199px, #0caebd 200px 200px, #0caebd 201px 201px, #0cafbd 202px 202px, #0cafbe 203px 203px, #0cafbe 204px 204px, #0cafbe 205px 205px, #0cafbe 206px 206px, #0cafbe 207px 207px, #0cafbe 208px 208px, #0cafbe 209px 209px, #0cafbe 210px 210px, #0cb0bf 211px 211px, #0cb0bf 212px 212px, #0cb0bf 213px 213px, #0cb0bf 214px 214px, #0cb0bf 215px 215px, #0cb0bf 216px 216px, #0cb0bf 217px 217px, #0cb0bf 218px 218px, #0cb0c0 219px 219px, #0cb1c0 220px 220px, #0cb1c0 221px 221px, #0cb1c0 222px 222px, #0cb1c0 223px 223px, #0cb1c0 224px 224px, #0cb1c0 225px 225px, #0cb1c0 226px 226px, #0cb1c1 227px 227px, #0cb1c1 228px 228px, #0cb2c1 229px 229px, #0cb2c1 230px 230px, #0cb2c1 231px 231px, #0cb2c1 232px 232px, #0cb2c1 233px 233px, #0cb2c1 234px 234px, #0cb2c2 235px 235px, #0cb2c2 236px 236px, #0cb2c2 237px 237px, #0cb3c2 238px 238px, #0cb3c2 239px 239px, #0cb3c2 240px 240px, #0cb3c2 241px 241px, #0cb3c2 242px 242px, #0cb3c3 243px 243px, #0cb3c3 244px 244px, #0db3c3 245px 245px, #0db3c3 246px 246px, #0db4c3 247px 247px, #0db4c3 248px 248px, #0db4c3 249px 249px, #0db4c3 250px 250px, #0db4c4 251px 251px, #0db4c4 252px 252px, #0db4c4 253px 253px, #0db4c4 254px 254px, #0db4c4 255px 255px, #0db5c4 256px 256px, #0db5c4 257px 257px, #0db5c4 258px 258px, #0db5c5 259px 259px, #0db5c5 260px 260px, #0db5c5 261px 261px, #0db5c5 262px 262px, #0db5c5 263px 263px, #0db5c5 264px 264px, #0db6c5 265px 265px, #0db6c5 266px 266px, #0db6c6 267px 267px, #0db6c6 268px 268px, #0db6c6 269px 269px, #0db6c6 270px 270px, #0db6c6 271px 271px, #0db6c6 272px 272px, #0db6c6 273px 273px, #0db7c6 274px 274px, #0db7c7 275px 275px, #0db7c7 276px 276px, #0db7c7 277px 277px, #0db7c7 278px 278px, #0db7c7 279px 279px, #0db7c7 280px 280px, #0db7c7 281px 281px, #0db7c7 282px 282px, #0db8c8 283px 283px, #0db8c8 284px 284px, #0db8c8 285px 285px, #0db8c8 286px 286px, #0db8c8 287px 287px, #0db8c8 288px 288px, #0db8c8 289px 289px, #0db8c8 290px 290px, #0db8c9 291px 291px, #0db9c9 292px 292px, #0db9c9 293px 293px, #0db9c9 294px 294px, #0db9c9 295px 295px, #0db9c9 296px 296px, #0db9c9 297px 297px, #0db9c9 298px 298px, #0db9ca 299px 299px, #0db9ca 300px 300px, #0dbaca 301px 301px, #0dbaca 302px 302px, #0dbaca 303px 303px, #0dbaca 304px 304px, #0dbaca 305px 305px, #0dbaca 306px 306px, #0dbacb 307px 307px, #0dbacb 308px 308px, #0dbacb 309px 309px, #0dbbcb 310px 310px, #0dbbcb 311px 311px, #0dbbcb 312px 312px, #0dbbcb 313px 313px, #0dbbcb 314px 314px, #0ebbcc 315px 315px, #0ebbcc 316px 316px, #0ebbcc 317px 317px, #0ebbcc 318px 318px, #0ebccc 319px 319px, #0ebccc 320px 320px, #0ebccc 321px 321px, #0ebccc 322px 322px, #0ebccd 323px 323px, #0ebccd 324px 324px, #0ebccd 325px 325px, #0ebccd 326px 326px, #0ebccd 327px 327px, #0ebdcd 328px 328px, #0ebdcd 329px 329px, #0ebdcd 330px 330px, #0ebdce 331px 331px, #0ebdce 332px 332px, #0ebdce 333px 333px, #0ebdce 334px 334px, #0ebdce 335px 335px, #0ebdce 336px 336px, #0ebece 337px 337px, #0ebece 338px 338px, #0ebecf 339px 339px, #0ebecf 340px 340px, #0ebecf 341px 341px, #0ebecf 342px 342px, #0ebecf 343px 343px, #0ebecf 344px 344px, #0ebecf 345px 345px, #0ebfcf 346px 346px, #0ebfd0 347px 347px, #0ebfd0 348px 348px, #0ebfd0 349px 349px
`
const SublimeText = styled.div`
  @media(min-width: 768px) {
    max-width: 30%;
    width: 300px;
    height: 200px;
    display: block;
    position: absolute;
    top: 150px;
    margin-top: 3px;
    z-index: 2;
    border-radius: 5px;
    box-shadow: #0998a4 1px 1px, #0998a4 2px 2px, #0998a4 3px 3px, #0998a5 4px 4px, #0999a5 5px 5px, #0999a5 6px 6px, #0999a5 7px 7px, #0999a5 8px 8px, #0999a5 9px 9px, #0999a5 10px 10px, #0999a5 11px 11px, #0999a6 12px 12px, #0999a6 13px 13px, #099aa6 14px 14px, #099aa6 15px 15px, #099aa6 16px 16px, #099aa6 17px 17px, #099aa6 18px 18px, #099aa6 19px 19px, #099aa7 20px 20px, #099aa7 21px 21px, #099aa7 22px 22px, #099ba7 23px 23px, #099ba7 24px 24px, #099ba7 25px 25px, #099ba7 26px 26px, #099ba7 27px 27px, #099ba8 28px 28px, #099ba8 29px 29px, #099ba8 30px 30px, #099ba8 31px 31px, #099ca8 32px 32px, #099ca8 33px 33px, #099ca8 34px 34px, #0a9ca8 35px 35px, #0a9ca9 36px 36px, #0a9ca9 37px 37px, #0a9ca9 38px 38px, #0a9ca9 39px 39px, #0a9ca9 40px 40px, #0a9da9 41px 41px, #0a9da9 42px 42px, #0a9da9 43px 43px, #0a9daa 44px 44px, #0a9daa 45px 45px, #0a9daa 46px 46px, #0a9daa 47px 47px, #0a9daa 48px 48px, #0a9daa 49px 49px, #0a9eaa 50px 50px, #0a9eaa 51px 51px, #0a9eab 52px 52px, #0a9eab 53px 53px, #0a9eab 54px 54px, #0a9eab 55px 55px, #0a9eab 56px 56px, #0a9eab 57px 57px, #0a9eab 58px 58px, #0a9fab 59px 59px, #0a9fac 60px 60px, #0a9fac 61px 61px, #0a9fac 62px 62px, #0a9fac 63px 63px, #0a9fac 64px 64px, #0a9fac 65px 65px, #0a9fac 66px 66px, #0a9fac 67px 67px, #0aa0ad 68px 68px, #0aa0ad 69px 69px, #0aa0ad 70px 70px, #0aa0ad 71px 71px, #0aa0ad 72px 72px, #0aa0ad 73px 73px, #0aa0ad 74px 74px, #0aa0ad 75px 75px, #0aa0ae 76px 76px, #0aa1ae 77px 77px, #0aa1ae 78px 78px, #0aa1ae 79px 79px, #0aa1ae 80px 80px, #0aa1ae 81px 81px, #0aa1ae 82px 82px, #0aa1ae 83px 83px, #0aa1af 84px 84px, #0aa1af 85px 85px, #0aa2af 86px 86px, #0aa2af 87px 87px, #0aa2af 88px 88px, #0aa2af 89px 89px, #0aa2af 90px 90px, #0aa2af 91px 91px, #0aa2b0 92px 92px, #0aa2b0 93px 93px, #0aa2b0 94px 94px, #0aa3b0 95px 95px, #0aa3b0 96px 96px, #0aa3b0 97px 97px, #0aa3b0 98px 98px, #0aa3b0 99px 99px, #0aa3b1 100px 100px, #0aa3b1 101px 101px, #0aa3b1 102px 102px, #0aa3b1 103px 103px, #0aa4b1 104px 104px, #0ba4b1 105px 105px, #0ba4b1 106px 106px, #0ba4b1 107px 107px, #0ba4b2 108px 108px, #0ba4b2 109px 109px, #0ba4b2 110px 110px, #0ba4b2 111px 111px, #0ba4b2 112px 112px, #0ba5b2 113px 113px, #0ba5b2 114px 114px, #0ba5b2 115px 115px, #0ba5b3 116px 116px, #0ba5b3 117px 117px, #0ba5b3 118px 118px, #0ba5b3 119px 119px, #0ba5b3 120px 120px, #0ba5b3 121px 121px, #0ba6b3 122px 122px, #0ba6b3 123px 123px, #0ba6b4 124px 124px, #0ba6b4 125px 125px, #0ba6b4 126px 126px, #0ba6b4 127px 127px, #0ba6b4 128px 128px, #0ba6b4 129px 129px, #0ba6b4 130px 130px, #0ba7b4 131px 131px, #0ba7b5 132px 132px, #0ba7b5 133px 133px, #0ba7b5 134px 134px, #0ba7b5 135px 135px, #0ba7b5 136px 136px, #0ba7b5 137px 137px, #0ba7b5 138px 138px, #0ba7b5 139px 139px, #0ba8b6 140px 140px, #0ba8b6 141px 141px, #0ba8b6 142px 142px, #0ba8b6 143px 143px, #0ba8b6 144px 144px, #0ba8b6 145px 145px, #0ba8b6 146px 146px, #0ba8b6 147px 147px, #0ba8b7 148px 148px, #0ba9b7 149px 149px, #0ba9b7 150px 150px, #0ba9b7 151px 151px, #0ba9b7 152px 152px, #0ba9b7 153px 153px, #0ba9b7 154px 154px, #0ba9b7 155px 155px, #0ba9b8 156px 156px, #0ba9b8 157px 157px, #0baab8 158px 158px, #0baab8 159px 159px, #0baab8 160px 160px, #0baab8 161px 161px, #0baab8 162px 162px, #0baab8 163px 163px, #0baab9 164px 164px, #0baab9 165px 165px, #0baab9 166px 166px, #0babb9 167px 167px, #0babb9 168px 168px, #0babb9 169px 169px, #0babb9 170px 170px, #0babb9 171px 171px, #0babba 172px 172px, #0babba 173px 173px, #0babba 174px 174px, #0cacba 175px 175px, #0cacba 176px 176px, #0cacba 177px 177px, #0cacba 178px 178px, #0cacbb 179px 179px, #0cacbb 180px 180px, #0cacbb 181px 181px, #0cacbb 182px 182px, #0cacbb 183px 183px, #0cadbb 184px 184px, #0cadbb 185px 185px, #0cadbb 186px 186px, #0cadbc 187px 187px, #0cadbc 188px 188px, #0cadbc 189px 189px, #0cadbc 190px 190px, #0cadbc 191px 191px, #0cadbc 192px 192px, #0caebc 193px 193px, #0caebc 194px 194px, #0caebd 195px 195px, #0caebd 196px 196px, #0caebd 197px 197px, #0caebd 198px 198px, #0caebd 199px 199px, #0caebd 200px 200px, #0caebd 201px 201px, #0cafbd 202px 202px, #0cafbe 203px 203px, #0cafbe 204px 204px, #0cafbe 205px 205px, #0cafbe 206px 206px, #0cafbe 207px 207px, #0cafbe 208px 208px, #0cafbe 209px 209px, #0cafbe 210px 210px, #0cb0bf 211px 211px, #0cb0bf 212px 212px, #0cb0bf 213px 213px, #0cb0bf 214px 214px, #0cb0bf 215px 215px, #0cb0bf 216px 216px, #0cb0bf 217px 217px, #0cb0bf 218px 218px, #0cb0c0 219px 219px, #0cb1c0 220px 220px, #0cb1c0 221px 221px, #0cb1c0 222px 222px, #0cb1c0 223px 223px, #0cb1c0 224px 224px, #0cb1c0 225px 225px, #0cb1c0 226px 226px, #0cb1c1 227px 227px, #0cb1c1 228px 228px, #0cb2c1 229px 229px, #0cb2c1 230px 230px, #0cb2c1 231px 231px, #0cb2c1 232px 232px, #0cb2c1 233px 233px, #0cb2c1 234px 234px, #0cb2c2 235px 235px, #0cb2c2 236px 236px, #0cb2c2 237px 237px, #0cb3c2 238px 238px, #0cb3c2 239px 239px, #0cb3c2 240px 240px, #0cb3c2 241px 241px, #0cb3c2 242px 242px, #0cb3c3 243px 243px, #0cb3c3 244px 244px, #0db3c3 245px 245px, #0db3c3 246px 246px, #0db4c3 247px 247px, #0db4c3 248px 248px, #0db4c3 249px 249px, #0db4c3 250px 250px, #0db4c4 251px 251px, #0db4c4 252px 252px, #0db4c4 253px 253px, #0db4c4 254px 254px, #0db4c4 255px 255px, #0db5c4 256px 256px, #0db5c4 257px 257px, #0db5c4 258px 258px, #0db5c5 259px 259px, #0db5c5 260px 260px, #0db5c5 261px 261px, #0db5c5 262px 262px, #0db5c5 263px 263px, #0db5c5 264px 264px, #0db6c5 265px 265px, #0db6c5 266px 266px, #0db6c6 267px 267px, #0db6c6 268px 268px, #0db6c6 269px 269px, #0db6c6 270px 270px, #0db6c6 271px 271px, #0db6c6 272px 272px, #0db6c6 273px 273px, #0db7c6 274px 274px, #0db7c7 275px 275px, #0db7c7 276px 276px, #0db7c7 277px 277px, #0db7c7 278px 278px, #0db7c7 279px 279px, #0db7c7 280px 280px, #0db7c7 281px 281px, #0db7c7 282px 282px, #0db8c8 283px 283px, #0db8c8 284px 284px, #0db8c8 285px 285px, #0db8c8 286px 286px, #0db8c8 287px 287px, #0db8c8 288px 288px, #0db8c8 289px 289px, #0db8c8 290px 290px, #0db8c9 291px 291px, #0db9c9 292px 292px, #0db9c9 293px 293px, #0db9c9 294px 294px, #0db9c9 295px 295px, #0db9c9 296px 296px, #0db9c9 297px 297px, #0db9c9 298px 298px, #0db9ca 299px 299px, #0db9ca 300px 300px, #0dbaca 301px 301px, #0dbaca 302px 302px, #0dbaca 303px 303px, #0dbaca 304px 304px, #0dbaca 305px 305px, #0dbaca 306px 306px, #0dbacb 307px 307px, #0dbacb 308px 308px, #0dbacb 309px 309px, #0dbbcb 310px 310px, #0dbbcb 311px 311px, #0dbbcb 312px 312px, #0dbbcb 313px 313px, #0dbbcb 314px 314px, #0ebbcc 315px 315px, #0ebbcc 316px 316px, #0ebbcc 317px 317px, #0ebbcc 318px 318px, #0ebccc 319px 319px, #0ebccc 320px 320px, #0ebccc 321px 321px, #0ebccc 322px 322px, #0ebccd 323px 323px, #0ebccd 324px 324px, #0ebccd 325px 325px, #0ebccd 326px 326px, #0ebccd 327px 327px, #0ebdcd 328px 328px, #0ebdcd 329px 329px, #0ebdcd 330px 330px, #0ebdce 331px 331px, #0ebdce 332px 332px, #0ebdce 333px 333px, #0ebdce 334px 334px, #0ebdce 335px 335px, #0ebdce 336px 336px, #0ebece 337px 337px, #0ebece 338px 338px, #0ebecf 339px 339px, #0ebecf 340px 340px, #0ebecf 341px 341px, #0ebecf 342px 342px, #0ebecf 343px 343px, #0ebecf 344px 344px, #0ebecf 345px 345px, #0ebfcf 346px 346px, #0ebfd0 347px 347px, #0ebfd0 348px 348px, #0ebfd0 349px 349px
  }
  @media(max-width: 767px) {
    display: none;
  }
`
const TopGrey = styled.div`
  width: 100%;
  height: 20px;
  background-color: #bfbfbf;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
`
const BottomGrey = styled.div`
  position: relative;
  height: 180px;
  width: 100%;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
`
const LeftGrey = styled.div`
  display: block;
  position: relative;
  background-color: #686868;
  width: 5%;
  float: left;
  height: 100%;
  border-bottom-left-radius: 5px;
`
const RightGrey = styled.div`
  display: block;
  position: relative;
  background-color: #272822;
  width: 95%;
  float: left;
  height: 100%;
  overflow: hidden;
  border-bottom-right-radius: 5px;
  > img {
    height: 100%;
    width: auto;
    background-color: #272822;
  }
`
const Server = styled.div`
  z-index: 4;
  display: block;
  top: 395px;
  position: absolute;
  height: 180px;
  max-width: 30%;
  width: 300px;
  background-color: white;
  border-radius: 10px;
  padding: 10px;
  box-shadow: #0998a4 1px 1px, #0998a4 2px 2px, #0998a4 3px 3px, #0998a5 4px 4px, #0999a5 5px 5px, #0999a5 6px 6px, #0999a5 7px 7px, #0999a5 8px 8px, #0999a5 9px 9px, #0999a5 10px 10px, #0999a5 11px 11px, #0999a6 12px 12px, #0999a6 13px 13px, #099aa6 14px 14px, #099aa6 15px 15px, #099aa6 16px 16px, #099aa6 17px 17px, #099aa6 18px 18px, #099aa6 19px 19px, #099aa7 20px 20px, #099aa7 21px 21px, #099aa7 22px 22px, #099ba7 23px 23px, #099ba7 24px 24px, #099ba7 25px 25px, #099ba7 26px 26px, #099ba7 27px 27px, #099ba8 28px 28px, #099ba8 29px 29px, #099ba8 30px 30px, #099ba8 31px 31px, #099ca8 32px 32px, #099ca8 33px 33px, #099ca8 34px 34px, #0a9ca8 35px 35px, #0a9ca9 36px 36px, #0a9ca9 37px 37px, #0a9ca9 38px 38px, #0a9ca9 39px 39px, #0a9ca9 40px 40px, #0a9da9 41px 41px, #0a9da9 42px 42px, #0a9da9 43px 43px, #0a9daa 44px 44px, #0a9daa 45px 45px, #0a9daa 46px 46px, #0a9daa 47px 47px, #0a9daa 48px 48px, #0a9daa 49px 49px, #0a9eaa 50px 50px, #0a9eaa 51px 51px, #0a9eab 52px 52px, #0a9eab 53px 53px, #0a9eab 54px 54px, #0a9eab 55px 55px, #0a9eab 56px 56px, #0a9eab 57px 57px, #0a9eab 58px 58px, #0a9fab 59px 59px, #0a9fac 60px 60px, #0a9fac 61px 61px, #0a9fac 62px 62px, #0a9fac 63px 63px, #0a9fac 64px 64px, #0a9fac 65px 65px, #0a9fac 66px 66px, #0a9fac 67px 67px, #0aa0ad 68px 68px, #0aa0ad 69px 69px, #0aa0ad 70px 70px, #0aa0ad 71px 71px, #0aa0ad 72px 72px, #0aa0ad 73px 73px, #0aa0ad 74px 74px, #0aa0ad 75px 75px, #0aa0ae 76px 76px, #0aa1ae 77px 77px, #0aa1ae 78px 78px, #0aa1ae 79px 79px, #0aa1ae 80px 80px, #0aa1ae 81px 81px, #0aa1ae 82px 82px, #0aa1ae 83px 83px, #0aa1af 84px 84px, #0aa1af 85px 85px, #0aa2af 86px 86px, #0aa2af 87px 87px, #0aa2af 88px 88px, #0aa2af 89px 89px, #0aa2af 90px 90px, #0aa2af 91px 91px, #0aa2b0 92px 92px, #0aa2b0 93px 93px, #0aa2b0 94px 94px, #0aa3b0 95px 95px, #0aa3b0 96px 96px, #0aa3b0 97px 97px, #0aa3b0 98px 98px, #0aa3b0 99px 99px, #0aa3b1 100px 100px, #0aa3b1 101px 101px, #0aa3b1 102px 102px, #0aa3b1 103px 103px, #0aa4b1 104px 104px, #0ba4b1 105px 105px, #0ba4b1 106px 106px, #0ba4b1 107px 107px, #0ba4b2 108px 108px, #0ba4b2 109px 109px, #0ba4b2 110px 110px, #0ba4b2 111px 111px, #0ba4b2 112px 112px, #0ba5b2 113px 113px, #0ba5b2 114px 114px, #0ba5b2 115px 115px, #0ba5b3 116px 116px, #0ba5b3 117px 117px, #0ba5b3 118px 118px, #0ba5b3 119px 119px, #0ba5b3 120px 120px, #0ba5b3 121px 121px, #0ba6b3 122px 122px, #0ba6b3 123px 123px, #0ba6b4 124px 124px, #0ba6b4 125px 125px, #0ba6b4 126px 126px, #0ba6b4 127px 127px, #0ba6b4 128px 128px, #0ba6b4 129px 129px, #0ba6b4 130px 130px, #0ba7b4 131px 131px, #0ba7b5 132px 132px, #0ba7b5 133px 133px, #0ba7b5 134px 134px, #0ba7b5 135px 135px, #0ba7b5 136px 136px, #0ba7b5 137px 137px, #0ba7b5 138px 138px, #0ba7b5 139px 139px, #0ba8b6 140px 140px, #0ba8b6 141px 141px, #0ba8b6 142px 142px, #0ba8b6 143px 143px, #0ba8b6 144px 144px, #0ba8b6 145px 145px, #0ba8b6 146px 146px, #0ba8b6 147px 147px, #0ba8b7 148px 148px, #0ba9b7 149px 149px, #0ba9b7 150px 150px, #0ba9b7 151px 151px, #0ba9b7 152px 152px, #0ba9b7 153px 153px, #0ba9b7 154px 154px, #0ba9b7 155px 155px, #0ba9b8 156px 156px, #0ba9b8 157px 157px, #0baab8 158px 158px, #0baab8 159px 159px, #0baab8 160px 160px, #0baab8 161px 161px, #0baab8 162px 162px, #0baab8 163px 163px, #0baab9 164px 164px, #0baab9 165px 165px, #0baab9 166px 166px, #0babb9 167px 167px, #0babb9 168px 168px, #0babb9 169px 169px, #0babb9 170px 170px, #0babb9 171px 171px, #0babba 172px 172px, #0babba 173px 173px, #0babba 174px 174px, #0cacba 175px 175px, #0cacba 176px 176px, #0cacba 177px 177px, #0cacba 178px 178px, #0cacbb 179px 179px, #0cacbb 180px 180px, #0cacbb 181px 181px, #0cacbb 182px 182px, #0cacbb 183px 183px, #0cadbb 184px 184px, #0cadbb 185px 185px, #0cadbb 186px 186px, #0cadbc 187px 187px, #0cadbc 188px 188px, #0cadbc 189px 189px, #0cadbc 190px 190px, #0cadbc 191px 191px, #0cadbc 192px 192px, #0caebc 193px 193px, #0caebc 194px 194px, #0caebd 195px 195px, #0caebd 196px 196px, #0caebd 197px 197px, #0caebd 198px 198px, #0caebd 199px 199px, #0caebd 200px 200px, #0caebd 201px 201px, #0cafbd 202px 202px, #0cafbe 203px 203px, #0cafbe 204px 204px, #0cafbe 205px 205px, #0cafbe 206px 206px, #0cafbe 207px 207px, #0cafbe 208px 208px, #0cafbe 209px 209px, #0cafbe 210px 210px, #0cb0bf 211px 211px, #0cb0bf 212px 212px, #0cb0bf 213px 213px, #0cb0bf 214px 214px, #0cb0bf 215px 215px, #0cb0bf 216px 216px, #0cb0bf 217px 217px, #0cb0bf 218px 218px, #0cb0c0 219px 219px, #0cb1c0 220px 220px, #0cb1c0 221px 221px, #0cb1c0 222px 222px, #0cb1c0 223px 223px, #0cb1c0 224px 224px, #0cb1c0 225px 225px, #0cb1c0 226px 226px, #0cb1c1 227px 227px, #0cb1c1 228px 228px, #0cb2c1 229px 229px, #0cb2c1 230px 230px, #0cb2c1 231px 231px, #0cb2c1 232px 232px, #0cb2c1 233px 233px, #0cb2c1 234px 234px, #0cb2c2 235px 235px, #0cb2c2 236px 236px, #0cb2c2 237px 237px, #0cb3c2 238px 238px, #0cb3c2 239px 239px, #0cb3c2 240px 240px, #0cb3c2 241px 241px, #0cb3c2 242px 242px, #0cb3c3 243px 243px, #0cb3c3 244px 244px, #0db3c3 245px 245px, #0db3c3 246px 246px, #0db4c3 247px 247px, #0db4c3 248px 248px, #0db4c3 249px 249px, #0db4c3 250px 250px, #0db4c4 251px 251px, #0db4c4 252px 252px, #0db4c4 253px 253px, #0db4c4 254px 254px, #0db4c4 255px 255px, #0db5c4 256px 256px, #0db5c4 257px 257px, #0db5c4 258px 258px, #0db5c5 259px 259px, #0db5c5 260px 260px, #0db5c5 261px 261px, #0db5c5 262px 262px, #0db5c5 263px 263px, #0db5c5 264px 264px, #0db6c5 265px 265px, #0db6c5 266px 266px, #0db6c6 267px 267px, #0db6c6 268px 268px, #0db6c6 269px 269px, #0db6c6 270px 270px, #0db6c6 271px 271px, #0db6c6 272px 272px, #0db6c6 273px 273px, #0db7c6 274px 274px, #0db7c7 275px 275px, #0db7c7 276px 276px, #0db7c7 277px 277px, #0db7c7 278px 278px, #0db7c7 279px 279px, #0db7c7 280px 280px, #0db7c7 281px 281px, #0db7c7 282px 282px, #0db8c8 283px 283px, #0db8c8 284px 284px, #0db8c8 285px 285px, #0db8c8 286px 286px, #0db8c8 287px 287px, #0db8c8 288px 288px, #0db8c8 289px 289px, #0db8c8 290px 290px, #0db8c9 291px 291px, #0db9c9 292px 292px, #0db9c9 293px 293px, #0db9c9 294px 294px, #0db9c9 295px 295px, #0db9c9 296px 296px, #0db9c9 297px 297px, #0db9c9 298px 298px, #0db9ca 299px 299px, #0db9ca 300px 300px, #0dbaca 301px 301px, #0dbaca 302px 302px, #0dbaca 303px 303px, #0dbaca 304px 304px, #0dbaca 305px 305px, #0dbaca 306px 306px, #0dbacb 307px 307px, #0dbacb 308px 308px, #0dbacb 309px 309px, #0dbbcb 310px 310px, #0dbbcb 311px 311px, #0dbbcb 312px 312px, #0dbbcb 313px 313px, #0dbbcb 314px 314px, #0ebbcc 315px 315px, #0ebbcc 316px 316px, #0ebbcc 317px 317px, #0ebbcc 318px 318px, #0ebccc 319px 319px, #0ebccc 320px 320px, #0ebccc 321px 321px, #0ebccc 322px 322px, #0ebccd 323px 323px, #0ebccd 324px 324px, #0ebccd 325px 325px, #0ebccd 326px 326px, #0ebccd 327px 327px, #0ebdcd 328px 328px, #0ebdcd 329px 329px, #0ebdcd 330px 330px, #0ebdce 331px 331px, #0ebdce 332px 332px, #0ebdce 333px 333px, #0ebdce 334px 334px, #0ebdce 335px 335px, #0ebdce 336px 336px, #0ebece 337px 337px, #0ebece 338px 338px, #0ebecf 339px 339px, #0ebecf 340px 340px, #0ebecf 341px 341px, #0ebecf 342px 342px, #0ebecf 343px 343px, #0ebecf 344px 344px, #0ebecf 345px 345px, #0ebfcf 346px 346px, #0ebfd0 347px 347px, #0ebfd0 348px 348px, #0ebfd0 349px 349px
  > img {
    height: 100%;
    width: 100%;
  }
  @media(max-width: 767px) { display: none; }
`
const DescriptionBox = styled.div`
  @media(min-width: 768px) {
    z-index: 6;
    position: absolute;
    left: 50%;
    top: 90px;
    padding-left: 158px;
    padding-right: 20px;
    color: white;
  }
  @media(max-width: 767px) {
    z-index: 10;
    position: relative;
    top: 20px;
    width: 85%;
    padding: 20px;
    color: white;
    background-color: rgba(0, 0, 0, 0.8);
    right: 0px;
    overflow: hidden;
    display: block;
    margin-left: auto;
  }
`
const DescriptionTextBox = styled.div`
  min-height: 275px;
  max-width: 330px;
`
const DescriptionBoxText1 = styled.div`
  font-size: 24px;
  font-family: SourceSansPro;
`
const DescriptionBoxText2 = styled.div`
  font-size: 22px;
  font-family: SourceSansPro;
  font-weight: 300;
`
const DescriptionBoxText3 = styled.div`
  font-size: 16px;
  font-family: SourceSansPro;
  font-weight: 300;
`
const Techbox = styled.div`
  margin-bottom: 20px;
`
const ImgTech = styled.img`
  box-sizing: border-box;
  border: 1px solid rgba(0, 0, 0, 0);
  height: 80px;
  width: auto;
  margin-right: 2px;
`

const Section4 = styled(Section)`
  display: block;
  height: 100%;
  background-color: #8c88ff;
  position: relative;
  overflow: hidden;
`
const Section4Mobile = styled.img`
  @media(min-width: 768px) {
    height: 80vh;
    position: absolute;
    top: 100px;
    left: 30vw;
    z-index: 5;
  }
  @media(max-width: 767px) {
    display: none;
  }
`
const Section4Graph = styled.img`
  z-index: 4;
  display: block;
  top: 180px;
  position: absolute;
  max-width: 30%;
  background-color: white;
  border-radius: 10px;
  padding: 10px;
  > img {
    height: 100%;
    width: 100%;
  }
  @media(max-width: 767px) { display: none; }
`
const Section5 = styled.div`
  display: block;
  width: 100%;
  background-color: #6565a2;
  position: relative;
  padding: 40px 0px;
`
const Section5Head = styled.div`
  width: auto;
  height: auto;
  font-family: FVAlmelo;
  font-size: 32px;
  color: white;
  text-shadow: 2px 2px rgba(0, 0, 0, 0.3);
  margin-bottom: 15px;
`
const ClientItemWrapper = styled.div`
  display: inline-block;
  vertical-align: top;
  background-color: white;
  border-radius: 10px;
  text-align: center;
  margin-bottom: 10px;
  margin-right: 10px;
  padding: 10px 0px;
  @media(min-width: 768px) {
    width: calc(25% - 7.5px);
    &:nth-child(4n) { margin-right: 0px; }
  }
  @media(min-width: 425px) and (max-width: 767px) {
    width: calc(33.33% - 6.67px);
    &:nth-child(3n) { margin-right: 0px; }
  }
  @media(max-width: 424px) {
    width: calc(50% - 5px);
    &:nth-child(2n) { margin-right: 0px; }
  }
`
const ClientImage = styled.img`
  width: 80%;
  height: 80px;
  object-fit: contain;
`
